// Split verification code input: one box per digit, combined into a hidden field
const DIGIT = ".js-verification-code-digit";

function digitsFor(element) {
  return [...element.closest(".js-verification-code").querySelectorAll(DIGIT)];
}

function sync(element) {
  const wrapper = element.closest(".js-verification-code");
  wrapper.querySelector(".js-verification-code-value").value = digitsFor(element).map(d => d.value).join("");
}

function fill(start, text) {
  const digits = digitsFor(start);
  let index = digits.indexOf(start);

  text.replace(/\D/g, "").split("").forEach(char => {
    if (index < digits.length) digits[index++].value = char;
  });

  digits[Math.min(index, digits.length - 1)].focus();
  sync(start);
}

document.addEventListener("input", ({ target }) => {
  if (!target.matches(DIGIT)) return;

  const value = target.value;
  target.value = "";
  fill(target, value);
});

document.addEventListener("paste", (event) => {
  if (!event.target.matches(DIGIT)) return;

  event.preventDefault();
  fill(event.target, event.clipboardData.getData("text"));
});

document.addEventListener("keydown", (event) => {
  const { target, key } = event;
  if (!target.matches(DIGIT)) return;

  const digits = digitsFor(target);
  const index = digits.indexOf(target);

  if (key === "Backspace" && target.value === "" && index > 0) {
    event.preventDefault();
    digits[index - 1].value = "";
    digits[index - 1].focus();
    sync(target);
  } else if (key === "ArrowLeft" && index > 0) {
    event.preventDefault();
    digits[index - 1].focus();
  } else if (key === "ArrowRight" && index < digits.length - 1) {
    event.preventDefault();
    digits[index + 1].focus();
  }
});

document.addEventListener("focusin", ({ target }) => {
  if (target.matches(DIGIT)) target.select();
});
